import axios from "axios";
import { useEffect, useState } from "react"
import { setShowLoading } from "../../features/sharedSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import RaporCard from "./RaporCard";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Button } from "primereact/button";

export default function RaporPanel() {
    const pdf = new jsPDF('landscape', undefined, 'A4');
    const dispatch = useAppDispatch()
    const services = useAppSelector(state => state.layer.services)
    const token = useAppSelector(state => state.authState.token);
    const [toplamOsb, setToplamOsb] = useState(0)
    const [toplamEb, setToplamEb] = useState(0)
    const [toplamIstihdam, setToplamIstihdam] = useState(0)
    const [toplamOsbAlan, setToplamOsbAlan] = useState(0)
    const [toplamSanayiParselAlan, setToplamSanayiParselAlan] = useState(0)
    const pdfPage = document.getElementById("tab1") as HTMLElement;

    const downloadPdf = () => {
        let page: any
        page = pdfPage

        html2canvas(page).then((canvas: any) => {
            pdf.addImage(canvas, "PNG", 10, 10, 270, 200);
            pdf.save("Ülke Geneli Raporu.pdf");
        });
    };

    const getIstihdamByOsb = async () => {
        try {
            const service = services.find(service => service.type === 'VECTOR')
            if (service) {
                const response = await axios.get(`${service.url}/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&typeName=osb_sinir_usr&maxFeatures=10&outputFormat=application/json&sortBy=istihdam_sayisi+D&propertyName=adi,istihdam_sayisi`)
                const features = response.data.features
                const categories = features.map((obj: any) => obj.properties.adi)
                const istihdam_sayisi = features.map((obj: any) => obj.properties.istihdam_sayisi)
                new (window as any).Highcharts.Chart({
                    colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                    chart: {
                        renderTo: 'osb_en_cok_istihdam_bilgisi',
                        type: 'column',
                        backgroundColor: '#1f2d40',
                        options3d: {
                            enabled: true,
                            alpha: 0,
                            beta: 0,
                            depth: 40,
                            viewDistance: 25
                        }
                    },
                    xAxis: {
                        gridLineWidth: 0,
                        categories: categories,
                        labels: {
                            style: { "color": "#ffffff", "fontSize": "10px" }
                        }
                    },
                    yAxis: {
                        title: {
                            enabled: false
                        },
                        labels: {
                            style: { "color": "#ffffff", "fontSize": "10px" }
                        },
                        tickInterval: 25000
                    },
                    tooltip: {
                        headerFormat: '<b>{point.key}</b><br>',
                        pointFormat: 'İstihdam Sayısı: {point.y}'
                    },
                    title: {
                        text: `En Çok İstihdamı Olan OSB' ler`,
                        style: { "color": "#ffffff", "fontSize": "14px" },
                        align: 'center'
                    },
                    legend: {
                        enabled: false
                    },
                    plotOptions: {
                        column: {
                            depth: 25
                        }
                    },
                    series: [{
                        data: istihdam_sayisi
                    }],
                    exporting: {
                        enabled: false
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
    }
    const getUretimFirmaByOsb = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/uretimfirmabyosb?token=${token}`)
            const data = response.data.data
            const categories = data.map((obj: any) => obj.adi)
            const firma_sayisi = data.map((obj: any) => Number(obj.count) ? Number(obj.count) : 0)
            new (window as any).Highcharts.Chart({
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    renderTo: 'osb_en_cok_uretim_bilgisi',
                    type: 'column',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 0,
                        beta: 0,
                        depth: 40,
                        viewDistance: 25
                    }
                },
                xAxis: {
                    gridLineWidth: 0,
                    minorTicks: true,
                    categories: categories,
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                yAxis: {
                    title: {
                        enabled: false
                    },
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    },
                    tickInterval: 2000
                },
                tooltip: {
                    headerFormat: '<b>{point.key}</b><br>',
                    pointFormat: 'Firma Sayısı: {point.y}'
                },
                title: {
                    text: `OSB Bazında En Çok Üretim Yapan Firma Sayısı`,
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'center'
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        depth: 25
                    }
                },
                series: [{
                    data: firma_sayisi
                }],
                exporting: {
                    enabled: false
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    const getFirmaBySektor = async () => {
        try {

            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/firmabysektor?token=${token}`)
            const data = response.data.data
            const chartData = data.map((obj: any) => { return [obj.nacerev2tanim, Number(obj.count) ? Number(obj.count) : 0] })
            new (window as any).Highcharts.Chart('toplam_sektor_bilgisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'Firma Sektör Bilgisi',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    width: '30%',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Değer',
                    data: chartData
                }]
            });

        } catch (error) {
            console.log(error);
        }
    }
    const getParselbyDurum = async () => {
        try {

            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/parselbydurum?token=${token}`)
            const data = response.data.data
            const chartData = data.map((obj: any) => {

                switch (obj.asamasi) {
                    case 1:
                        return ['Proje', Number(obj.count) ? Number(obj.count) : 0]
                    case 2:
                        return ['İnşaat', Number(obj.count) ? Number(obj.count) : 0]
                    case 3:
                        return ['Üretim', Number(obj.count) ? Number(obj.count) : 0]
                    default:
                        break;
                }
            })

            new (window as any).Highcharts.Chart('toplam_parsel_durumu_bilgisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'Parsel Durumu',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Değer',
                    data: chartData
                }]
            });

        } catch (error) {
            console.log(error);
        }
    }
    const getOsbbyTur = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/osbbytur?token=${token}`)
            const data = response.data.data

            const chartData = data.map((obj: any) => {

                switch (obj.osb_turu) {
                    case 1:
                        return ['İhtisas', Number(obj.count) ? Number(obj.count) : 0]
                    case 2:
                        return ['Karma', Number(obj.count) ? Number(obj.count) : 0]
                    case 3:
                        return ['Özel', Number(obj.count) ? Number(obj.count) : 0]
                    default:
                        break;
                }
            })
            new (window as any).Highcharts.Chart('osb_turu_sayisi_bilgisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                title: {
                    text: 'OSB Türü Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Değer',
                    data: chartData
                }],
                exporting: {
                    enabled: false
                }
            });

        } catch (error) {
            console.log(error);
        }
    }
    const getParselAlaniByTahsis = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/parselalanibytahsis?token=${token}`)
            const data = response.data.data
            const categories = data.map((obj: any) => obj.type)
            const alan = data.map((obj: any) => !Number.isNaN(Number(obj.alan)) ? parseFloat(Number(obj.alan).toLocaleString()) : 0)
            const fixed = [parseFloat(alan[0].toFixed(2)), parseFloat(alan[1].toFixed(2))]

            new (window as any).Highcharts.Chart('toplam_parsel_alani_bilgisi', {
                colors: ['#b68a33', '#60471c'],
                chart: {
                    type: 'column',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 0,
                        beta: 5,
                        depth: 30,
                        viewDistance: 5
                    },
                    marginLeft: 3
                },
                xAxis: {
                    gridLineWidth: 0,
                    categories: categories,
                    labels: {
                        enabled: true,
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    },
                    title: {
                        enabled: false
                    }
                },
                yAxis: {
                    gridLineWidth: 0,
                    labels: {
                        enabled: false
                    },
                    title: {
                        enabled: false
                    }
                },
                tooltip: {
                    headerFormat: '<b>{point.key}</b><br>',
                    pointFormat: 'Parsel Alanı: {point.y}(ha)'
                },
                title: {
                    text: `Parsel Alanı`,
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                }, legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        depth: 25,
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                series: [{
                    pointWidth: 110,
                    data: fixed,
                    colorByPoint: true,
                }],
                exporting: {
                    enabled: false
                }
            });
            dispatch(setShowLoading(false));
        } catch (error) {
            console.log(error);
        }
    }
    const getParselSayisiByTahsis = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/parselsayisibytahsis?token=${token}`)
            const data = response.data.data
            const categories = ['Tahsis Yapılan Parsel Sayısı', 'Boş Parsel Sayısı']
            const count = data.map((obj: any) => Number(obj.count) ? parseFloat(Number(obj.count).toLocaleString()) : 0)

            new (window as any).Highcharts.Chart('toplam_parsel_sayisi_bilgisi', {
                colors: ['#b68a33', '#60471c'],
                chart: {
                    type: 'column',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 0,
                        beta: 5,
                        depth: 30,
                        viewDistance: 5
                    },
                    marginLeft: 3
                },
                xAxis: {
                    gridLineWidth: 0,
                    categories: categories,
                    labels: {
                        enabled: true,
                        style: { "color": "#ffffff", "fontSize": "12px" }
                    },
                    title: {
                        enabled: false
                    }
                },
                yAxis: {
                    gridLineWidth: 0,
                    labels: {
                        enabled: false
                    },
                    title: {
                        enabled: false
                    }
                },
                tooltip: {
                    headerFormat: '<b>{point.key}</b><br>',
                    pointFormat: 'Parsel Sayısı: {point.y}'
                },
                title: {
                    text: `OSB Türü Sayısı`,
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                }, legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        depth: 25,
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                series: [{
                    pointWidth: 110,
                    data: count,
                    colorByPoint: true
                }],
                exporting: {
                    enabled: false
                }
            });


        } catch (error) {
            console.log(error);
        }
    }
    const getToplamKartBilgileri = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/toplamkartbilgileri?token=${token}`)
            const data = response.data.data
            setToplamOsb(data.find((obj: any) => obj.type === 'osb_sayisi')?.value)
            setToplamEb(data.find((obj: any) => obj.type === 'eb_sayisi')?.value)
            setToplamIstihdam(data.find((obj: any) => obj.type === 'osb_istihdam_sayisi')?.value)
            setToplamOsbAlan(Math.round(data.find((obj: any) => obj.type === 'toplam_osb_alani')?.value))
            setToplamSanayiParselAlan(Math.round(data.find((obj: any) => obj.type === 'sanayi_parseli_alani')?.value))
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        dispatch(setShowLoading(true));
        getFirmaBySektor();
        getIstihdamByOsb();
        getUretimFirmaByOsb();
        getParselbyDurum();
        getOsbbyTur();
        getParselAlaniByTahsis();
        getParselSayisiByTahsis();
        getToplamKartBilgileri();
    }, [])

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px'}}><Button className="pdf-button" label='PDF Dışa Aktar' onClick={downloadPdf} /></div>
            <div className="rapor-row-container" id="tab1">
                <div className="rapor-row" style={{ width: '25%', height: '100%' }}>
                    <div id="toplam_sektor_bilgisi" className="rapor-row-element" style={{ width: '100%', height: '32%' }}></div>
                    <div id="toplam_parsel_durumu_bilgisi" className="rapor-row-element" style={{ width: '100%', height: '32%' }}></div>
                    <div id="toplam_parsel_alani_bilgisi" className="rapor-row-element" style={{ width: '100%', height: '32%' }}></div>
                </div>
                <div className="rapor-row" style={{ width: '50%', height: '100%' }}>
                    <div id="osb_en_cok_uretim_bilgisi" className="rapor-row-element" style={{ width: '100%', height: '41%' }}></div>
                    <div id="osb_en_cok_istihdam_bilgisi" className="rapor-row-element" style={{ width: '100%', height: '41%' }}></div>
                    <div className="rapor-row-element" style={{ width: '100%', height: '15%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
                        <div style={{ width: '30%', height: '90%' }}>
                            <RaporCard header="OSB SAYISI" value={toplamOsb.toLocaleString()}></RaporCard>
                        </div>
                        <div style={{ width: '30%', height: '90%' }}>
                            <RaporCard header="ENDÜSTRİ BÖLGE SAYISI" value={toplamEb.toLocaleString()}></RaporCard>
                        </div>
                        <div style={{ width: '30%', height: '90%' }}>
                            <RaporCard header="OSB TOPLAM İSTİHDAM SAYISI" value={toplamIstihdam?.toLocaleString()}></RaporCard>
                        </div>
                    </div>
                </div>
                <div className="rapor-row" style={{ width: '25%', height: '100%' }}>
                    <div className="rapor-row-element" style={{ width: '100%', height: '32%', display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center' }}>
                        <div style={{ width: '80%', height: '45%' }}>
                            <RaporCard header="OSB ALANI (ha)" value={toplamOsbAlan.toLocaleString()}></RaporCard>
                        </div>
                        <div style={{ width: '80%', height: '45%' }}>
                            <RaporCard header="SANAYİ PARSEL ALANI (ha)" value={toplamSanayiParselAlan.toLocaleString()}></RaporCard>
                        </div>
                    </div>
                    <div id="osb_turu_sayisi_bilgisi" className="rapor-row-element" style={{ width: '100%', height: '32%' }}></div>
                    <div id="toplam_parsel_sayisi_bilgisi" className="rapor-row-element" style={{ width: '100%', height: '32%' }}></div>
                </div>
            </div>
        </>
    )
}
